/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_One_Plus_OneInputs */

const cs_enum_one_plus_one = /** @type {(inputs: Enum_One_Plus_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1+1`)
};

const en_enum_one_plus_one = /** @type {(inputs: Enum_One_Plus_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1+1`)
};

/**
* | output |
* | --- |
* | "1+1" |
*
* @param {Enum_One_Plus_OneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_one_plus_one = /** @type {((inputs?: Enum_One_Plus_OneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_One_Plus_OneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_one_plus_one(inputs)
	return cs_enum_one_plus_one(inputs)
});